import { Link } from 'react-router-dom';
import { RTBLogo } from '@/components/RTBLogo';

export default function PrivacyPolicy() {
  return (
    <div className="min-h-screen bg-white">
      <header className="border-b border-gray-100 py-4 px-6">
        <Link to="/" className="inline-block"><RTBLogo className="h-8" /></Link>
      </header>
      <div className="max-w-3xl mx-auto px-6 py-12" data-testid="privacy-page">
        <h1 className="text-3xl font-oswald font-bold text-gray-900 mb-8">Privacy Policy</h1>
        <div className="prose prose-gray max-w-none text-gray-600 space-y-6 text-sm leading-relaxed">
          <p><strong>Last Updated:</strong> March 25, 2026</p>

          <h2 className="text-lg font-bold text-gray-900 mt-8">1. Information We Collect</h2>
          <p><strong>Personal Information:</strong> When you register, we collect your name, email address, phone number, and payment information. When you use our services, we may collect additional information such as your questionnaire responses, program progress, and communication history.</p>
          <p><strong>Automatically Collected Data:</strong> We collect device information, IP addresses, browser type, pages visited, and usage patterns through cookies and similar technologies.</p>

          <h2 className="text-lg font-bold text-gray-900 mt-8">2. How We Use Your Information</h2>
          <p>We use your information to: (a) provide and improve our services; (b) process payments; (c) send transactional emails and SMS notifications; (d) personalize your program experience; (e) comply with legal obligations; (f) communicate important updates about the program.</p>

          <h2 className="text-lg font-bold text-gray-900 mt-8">3. Third-Party Services</h2>
          <p>We use the following third-party services that may process your data:</p>
          <ul className="list-disc pl-6 space-y-1">
            <li><strong>Whop</strong> — Payment processing</li>
            <li><strong>Brevo</strong> — Email and SMS communications</li>
            <li><strong>Checkr</strong> — Background check services (when applicable)</li>
            <li><strong>HeyGen</strong> — AI video generation</li>
          </ul>
          <p>Each provider has their own privacy policy governing their use of your data.</p>

          <h2 className="text-lg font-bold text-gray-900 mt-8">4. Data Storage & Security</h2>
          <p>Your data is stored securely using industry-standard encryption and access controls. We retain your personal information for as long as your account is active or as needed to provide services, comply with legal obligations, resolve disputes, and enforce our agreements.</p>

          <h2 className="text-lg font-bold text-gray-900 mt-8">5. Your Rights</h2>
          <p>You have the right to: (a) access your personal data; (b) correct inaccurate data; (c) request deletion of your data; (d) opt out of marketing communications; (e) request a copy of your data in a portable format. Contact us to exercise these rights.</p>

          <h2 className="text-lg font-bold text-gray-900 mt-8">6. Cookies</h2>
          <p>We use cookies and similar technologies to enhance your experience, analyze usage, and assist in our marketing efforts. You can control cookie settings through your browser preferences.</p>

          <h2 className="text-lg font-bold text-gray-900 mt-8">7. Children's Privacy</h2>
          <p>Our services are not directed to individuals under 18. We do not knowingly collect personal information from children.</p>

          <h2 className="text-lg font-bold text-gray-900 mt-8">8. Changes to This Policy</h2>
          <p>We may update this Privacy Policy from time to time. We will notify you of material changes via email or through the platform.</p>

          <h2 className="text-lg font-bold text-gray-900 mt-8">9. Contact</h2>
          <p>For privacy-related inquiries, contact us at <a href="mailto:privacy@readytobuildit.life" className="text-rtb-purple">privacy@readytobuildit.life</a>.</p>
        </div>
      </div>
    </div>
  );
}
